import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { PAPriceDetail } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        MemberID: '',
        CarrierCode: '',
        AccountNumber: '',
        GroupCode: '',
        PriorAuthorizationNumber: '',
        TroopScheduleCode: '',
        EgwpTroopScheduleCode: '',
        PpScheduleName: '',
        PriceScheduleName: '',
        CopayScheduleName: '',
        CopayStepNumber: '',
        CopayIndicator: '',
        ClientPriceSchedule: '',
        ProductSelectionCode: '',
        MacScheduleCode: '',
        PnpStatus: '',
        CostType: '',
        CostValue: '',
        FeeScheduleName: '',
        FeeScheduleStepNumber: '',
        IncentiveFeeScheduleStep: '',
        CostSource: '',
        BenefitMaxAccumCode: '',
        LifeMaxAccumCode: '',
        PharmacyAmountDueSchedule: '',
        ClientAmountDueSchedule: '',
        CsrAccumulatedDeductibleSchedule: '',
        CsrAccumulatedOopSchedule: '',
        OtcIndicator: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "MemberID",
        collectionName: "PA PriceDetail"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        AccountNumber: false,
        GroupCode: false,
        MemberID: false,
        CarrierCode: false,
        PriorAuthorizationNumber: false,
    }
}

export const getPAPriceDetailData = createAsyncThunk('data/getPAPriceDetailData',
    async (data, { rejectWithValue }) => {
        try {
            let queryPAPrice =
                `query GetPriorAuthPriceDetails{
                    GetPriorAuthPriceDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"PA PriceDetail",
                isDownload:false,
                ${data.CarrierCode ? `,carrier: "${data.CarrierCode}"` : ""}
                ${data.MemberID ? `,memberid: "${data.MemberID}"` : ""}
                ${data.AccountNumber ? `,account: "${data.AccountNumber}"` : ""}
                ${data.GroupCode ? `,group: "${data.GroupCode}"` : ""}
                ${data.PriorAuthorizationNumber ? `,panumber: "${data.PriorAuthorizationNumber}"` : ""}
                `;

            queryPAPrice += PAPriceDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryPAPrice, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getPAPriceDetailDownloadAll = createAsyncThunk('data/getPAPriceDetailDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryPAPriceAll =
                `query GetPriorAuthPriceDetails{
                    GetPriorAuthPriceDetails(
                    collectionName:"PA PriceDetail",
                    isDownload:true,
                    ${data.CarrierCode ? `,carrier: "${data.CarrierCode}"` : ""}
                    ${data.MemberID ? `,memberid: "${data.MemberID}"` : ""}
                    ${data.AccountNumber ? `,account: "${data.AccountNumber}"` : ""}
                    ${data.GroupCode ? `,group: "${data.GroupCode}"` : ""}
                    ${data.PriorAuthorizationNumber ? `,panumber: "${data.PriorAuthorizationNumber}"` : ""}
                        `;

            queryPAPriceAll += PAPriceDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryPAPriceAll, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const paPriceDetailSlice = createSlice({
    name: 'paPrice',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPAPriceDetailData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getPAPriceDetailData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetPriorAuthPriceDetails.totalCount;
                state.data.tableData = response.data.data.GetPriorAuthPriceDetails.data;
            })
            .addCase(getPAPriceDetailData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getPAPriceDetailDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getPAPriceDetailDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.tableData = response.data.data.GetPriorAuthPriceDetails.data;
            })
            .addCase(getPAPriceDetailDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = paPriceDetailSlice.actions;
export default paPriceDetailSlice.reducer